import { useLocation } from 'react-router-dom';
import { Route } from '../interface/Route';

/*
 * Custom React hook: useHeaderConfig
 *
 * This hook returns a header configuration object based on
 * the current URL path. It compares the user's current
 * location (pathname) with a list of predefined route objects.
 *
 * Parameters:
 *   routes (Route[])
 *     - An array of route definitions.
 *     - Each route should contain:
 *         path: string        → URL path for the route
 *         headerConfig: {     → Optional configuration for the header
 *           datePicker?: boolean
 *           search?: boolean
 *           sumBy?: boolean
 *           columnOrder?: boolean
 *           exportToExcel?: boolean
 *           exportToPDF?: boolean
 *         }
 *
 * Behavior:
 *   - It uses react-router's useLocation() to get the current pathname.
 *   - It searches the "routes" array to find a route whose "path"
 *     matches the current URL.
 *   - If a matching route is found, it returns that route's headerConfig.
 *   - If no matching route exists, it returns a default config:
 *       { datePicker: false, search: false, sumBy: false, columnOrder: false, exportToExcel: false, exportToPDF: false }
 *
 */

export function useHeaderConfig(routes: Route[]) {
  const location = useLocation();
  return (
    routes.find((route) => route.path === location.pathname)?.headerConfig || {
      datePicker: false,
      search: false,
      sumBy: false,
      columnOrder: false,
      exportToExcel: false,
      exportToPDF: false,
      updateData: false,
    }
  );
}
